<template>
<section class="section">
  <div class="container">
    <div class="columns">
      <div class="column">
        <div class="columns is-desktop">
          <div class="column is-6">
            <div class="field">
              <div class="control">
                <input type="text" class="input" placeholder="Search by email" v-model="searchText">
              </div>
            </div>
          </div>
          <div class="column is-3">
              <date-picker v-model="dates" range></date-picker>
            </div>
          <div class="column is-2">
            <button class="button is-info is-fullwidth" @click="onFilter">Search</button>
          </div>
        </div>
        
        <div>

          <div class="d-flex gap20 mb-4">
            <div class="white-common-box p-4" style="flex: 2;">
              <div class="font-weight-bold mb-4" style="font-size: 1rem;">Total users per tool:</div>
              <ul>
                <li v-for="item in totalUsersPerTool" :key="item.label" class="mb-1">
                  <strong>{{ item.label }}</strong>: {{ item.value }}
                </li>
              </ul>
            </div>
            <div class="white-common-box p-4" style="flex: 1;">
              <div class="font-weight-bold mb-4" style="font-size: 1rem;">Total users:</div>
              <div style="font-size: 2rem;">{{ totalUsers }}</div>
            </div>
          </div>

          <div class="white-common-box p-4 mb-4">
            <div class="font-weight-bold mb-2" style="font-size: 1rem;">Stats by user:</div>
            
            <b-table
              :data="dataByUser"
              :loading="isLoading"
              paginated
              :per-page="100"
              >
              <template slot-scope="props">
                <b-table-column field="user_id" label="User ID" sortable numeric>{{ props.row.user_id }}</b-table-column>
                <b-table-column field="email" label="Email" sortable>{{ props.row.email }}</b-table-column>
    
                <b-table-column field="keyword_insight_result.usage_count" label="Keyword Insight - Times Used" sortable>{{ props.row?.keyword_insight_result?.usage_count || 0 }}</b-table-column>
                <b-table-column field="keyword_insight_result.credits_used" label="Keyword Insight - Credits Spent" sortable>{{ props.row?.keyword_insight_result?.credits_used || 0 }}</b-table-column>
    
                <b-table-column field="one_click_silo_result.usage_count" label="1-Click Silo - Times Used" sortable>{{ props.row?.one_click_silo_result?.usage_count || 0 }}</b-table-column>
                <b-table-column field="one_click_silo_result.credits_used" label="1-Click Silo - Credits Spent" sortable>{{ props.row?.one_click_silo_result?.credits_used || 0 }}</b-table-column>
    
                <b-table-column field="custom_silo_keywords_result.usage_count" label="Custom Silo - Get Keywrds - Times Used" sortable>{{ props.row?.custom_silo_keywords_result?.usage_count || 0 }}</b-table-column>
                <b-table-column field="custom_silo_keywords_result.credits_used" label="Custom Silo - Get Keywords - Credits Spent" sortable>{{ props.row?.custom_silo_keywords_result?.credits_used || 0 }}</b-table-column>
    
                <b-table-column field="custom_silo_metrics_result.usage_count" label="Custom Silo - Get Metrics - Times Used" sortable>{{ props.row?.custom_silo_metrics_result?.usage_count || 0 }}</b-table-column>
                <b-table-column field="custom_silo_metrics_result.credits_used" label="Custom Silo - Get Metrics - Credits Spent" sortable>{{ props.row?.custom_silo_metrics_result?.credits_used || 0 }}</b-table-column>
    
                <b-table-column field="keyword_track_result.usage_count" label="Keyword Track - Keywords Tracked" sortable>{{ props.row?.keyword_track_result?.keywords_tracked || 0 }}</b-table-column>
  
                <b-table-column field="total_credits_used" label="Total Credits Spent" sortable>{{ props.row?.total_credits_used || 0 }}</b-table-column>
              </template>
            </b-table>
          </div>

        </div>
        
      </div>
    </div>

  </div>
</section>
</template>

<script>
import moment from 'moment'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';


export default {
  components: { DatePicker },
  data () {
    return {
      data: {},
      isLoading: false,
      dates: [moment().subtract(1, 'months').toDate(), moment().toDate()],
      searchText: '',
    }
  },
  computed: {
    currentUser () {
      if (this.$store.state.user) {
        return this.$store.state.user.id
      }
      return {}
    },
    totalUsers () {
      return [...new Set(
        [
          ...this.data?.keyword_insight_result || [],
          ...this.data?.one_click_silo_result || [],
          ...this.data?.custom_silo_keywords_result || [],
          ...this.data?.custom_silo_metrics_result || [],
          ...this.data?.keyword_track_result || [],
        ].map(item => item.user_id)
      )].length
    },
    totalUsersPerTool () {
      return [
        {
          label: 'Keyword Insight',
          value: this.data?.keyword_insight_result?.length || 0,
        },
        {
          label: '1-Click Silo',
          value: this.data?.one_click_silo_result?.length || 0,
        },
        {
          label: 'Custom Silo - Get Keywords',
          value: this.data?.custom_silo_keywords_result?.length || 0,
        },
        {
          label: 'Custom Silo - Get Metrics',
          value: this.data?.custom_silo_metrics_result?.length || 0,
        },
        {
          label: 'Keyword Track (all time)',
          value: this.data?.keyword_track_result?.length || 0,
        }
      ]
    },
    dataByUser () {
      let data = {};

      (this.data?.keyword_insight_result || []).forEach(item => {
        data[item.user_id] = {
          ...(data[item.user_id] || {}),
          'user_id': item.user_id,
          'email': item.email,
          'keyword_insight_result': item
        }
      });

      (this.data?.one_click_silo_result || []).forEach(item => {
        data[item.user_id] = {
          ...(data[item.user_id] || {}),
          'user_id': item.user_id,
          'email': item.email,
          'one_click_silo_result': item
        }
      });

      (this.data?.custom_silo_keywords_result || []).forEach(item => {
        data[item.user_id] = {
          ...(data[item.user_id] || {}),
          'user_id': item.user_id,
          'email': item.email,
          'custom_silo_keywords_result': item
        }
      });

      (this.data?.custom_silo_metrics_result || []).forEach(item => {
        data[item.user_id] = {
          ...(data[item.user_id] || {}),
          'user_id': item.user_id,
          'email': item.email,
          'custom_silo_metrics_result': item
        }
      });

      (this.data?.keyword_track_result || []).forEach(item => {
        data[item.user_id] = {
          ...(data[item.user_id] || {}),
          'user_id': item.user_id,
          'email': item.email,
          'keyword_track_result': item
        }
      });

      data = Object.values(data)

      data = data.map(row => {
        return {
          ...row,
          total_credits_used: [
            row?.keyword_insight_result?.credits_used || 0,
            row?.one_click_silo_result?.credits_used || 0,
            row?.custom_silo_keywords_result?.credits_used || 0,
            row?.custom_silo_metrics_result?.credits_used || 0,
          ].reduce((partialSum, a) => partialSum + a, 0)
        }
      })

      return data
    },
  },
  methods: {
    onFilter () {
      // console.log('filtering')
      this.$nextTick(() => {
        this.loadData()
      })
    },
    loadData () {
      this.isLoading = true
      this.$store.commit('showLoading')

      let startDate = this.dates[0]?moment(this.dates[0]).startOf('day').toDate():null;
      let endDate = this.dates[1]?moment(this.dates[1]).endOf('day').toDate():null;

      let params = [
        `filterText=${this.searchText}`
      ]
      
      if (startDate) {
        params.push(`startDate=${startDate.getTime()}`)
      }
      if (endDate) {
        params.push(`endDate=${endDate.getTime()}`)
      }

      params = params.join('&')
      
      this.$store.dispatch('loadKeywordResearchUsageForAdmin', { params })
        .then(({ data }) => {
          this.data = data
        })
        .finally(() => {
          this.isLoading = false
          this.$store.commit('hideLoading')
        })
    },
  },
  beforeMount () {
    this.loadData()
  }
}
</script>

<style lang="scss">
.table-mobile-sort {
  display: none;
}
</style>
